import { magentoApi } from "./magentoApi";

export async function fetchQuote(oid, qid) {
  const data = await magentoApi.get(`canon/quote?oid=${oid}&qid=${qid}`);

  if (data.message) {
    throw new Error(data.message);
  }

  return data[0];
}

export async function submitQuote(quoteData, opportunity) {
  let result = await magentoApi.post("canon/sfdc/saveQuote", {
    quoteDataEncoded: JSON.stringify(quoteData),
    opportunityEncoded: JSON.stringify(opportunity)
  });

  // The response can be double encoded by the backend to bypass the undesired behavior of Magento on data object or array.
  if (typeof result === "string") {
    result = JSON.parse(result);
  }

  if (!result.status) {
    throw new Error(result.message || "Quote submission failed.");
  }

  return result;
}

export async function validateQuoteItems(quoteItems, customerGroupId) {
  return await magentoApi.post("canon/quote/checkAvailability", {
    quoteItems,
    customerGroupId
  });
}

export async function validateQuote(quoteData) {
  return await magentoApi.post("canon/sfdc/validateQuote", {
    quoteDataEncoded: JSON.stringify(quoteData),
  });
}

export function fetchPriceFlags(isMsa, opportunityType) {
  return magentoApi.get(
    `canon/sfdc/priceFlags?isMsa=${
      isMsa ? 1 : 0
    }&opportunityType=${opportunityType}`
  );
}
